<template>
  <div class="wrapper" :style="cssProps">
    <div class="loading">
      <pulse-loader
        :color="'#af7c00'"
        :size="'2em'"
        :loading="loading"
      ></pulse-loader>
    </div>
    <div class="header" v-if="!loading">
      <img :src="backIcon" @click="back" class="back" />
      <parkenda-menu class="menu"></parkenda-menu>
    </div>
    <div class="content" v-if="!loading">
      <div class="label">
        <p class="text">{{ this.$store.getters.TRANSLATIONS["doorjam"] }}</p>
      </div>
      <p class="content_title">
        {{ this.$store.getters.TRANSLATIONS["associate_doorjam"] }}
      </p>
      <input
        type="text"
        v-model="doorjam"
        :placeholder="this.$store.getters.TRANSLATIONS['doorjam_code']"
        class="firstName"
        autocomplete="off"
      />
    </div>
    <div class="footer" v-if="!loading">
      <button v-on:click="validateCode()" class="button">
        {{ this.$store.getters.TRANSLATIONS["associate"] }}
      </button>
    </div>
    <v-dialog style="margin-top: 25%" :width="350" />
    <parkenda-toolbar v-if="!loading"></parkenda-toolbar>
  </div>
</template>

<script>
export default {
  beforeCreate: function () {
    console.log("before created");
    console.log(this.$store.getters.USER.selectedCar);
  },
  created: function () {
    if (!this.$storage.get("parkendaToken") || !this.$store.getters.USER) {
      this.$router.push("/login");
    }
  },
  data() {
    console.log("data");
    return {
      loading: false,
      cssProps: {
        backgroundImage: `url(${require("@/assets/new_design/AdobeStock_317642058.png")})`,
        "background-position": "center",
        "background-repeat": "no-repeat",
        "background-size": "cover"
      },
      doorjam: "",
      backIcon: require("@/assets/new_design/Polygon_3.png"),
      associateCode: (doorjamObj) => {
        const timeout = setTimeout(() => {
          this.loading = true;
        }, 0);
        this.$http
          .put(
            `${process.env.SERVER_URL}/C06ABF76861B4A8F9A27E3F222DF8A57`,
            doorjamObj,
            {
              headers: {
                "x-access-token": this.$storage.get("parkendaToken")
              }
            }
          )
          .then((response) => {
            console.log("Associate doorjam response");
            console.log(response);
            if (response.data && response.status && response.status === 200) {
              let USER = this.$store.getters.USER;
              USER.selectedCar.doorjamCode = this.doorjam;
              this.$store.dispatch("SAVE_USER", USER);
              this.back();
            }
          })
          .catch((error) => {
            let text = this.$store.getters.TRANSLATIONS["something_went_wrong"];
            if (
              error.response &&
              error.response.data &&
              error.response.data.error
            ) {
              text = error.response.data.error;
            }
            this.$modal.show("dialog", {
              text,
              buttons: [
                {
                  title: "OK",
                  handler: () => {
                    this.$modal.hide("dialog");
                  }
                }
              ]
            });
          })
          .finally(() => {
            clearTimeout(timeout);
            this.loading = false;
          });
      },
      validateCode: () => {
        const doorjamCode = this.doorjam;
        const barcode = this.$store.getters.USER.barcode;
        const vehicleId = this.$store.getters.USER.selectedCar.id;
        const timeout = setTimeout(() => {
          this.loading = true;
        }, 0);
        return this.$http
          .get(
            `${process.env.SERVER_URL}/1143E485FE28433FB5C76CCCF19A2F8D/${barcode}/${doorjamCode}`,
            {
              headers: {
                "x-access-token": this.$storage.get("parkendaToken")
              }
            }
          )
          .then((response) => {
            console.log("Verify doorjam code response:");
            console.log(response);
            if (response.data) {
              const doorjam = response.data.doorjam;
              const member = response.data.member;
              if (doorjam.vehicleId && doorjam.vehicleId !== vehicleId) {
                let text =
                  this.$store.getters.TRANSLATIONS["the_doorjam_code_another"];
                this.$modal.show("dialog", {
                  text,
                  buttons: [
                    {
                      title: "OK",
                      handler: () => {
                        this.$modal.hide("dialog");
                      }
                    }
                  ]
                });
              } else {
                this.associateCode({
                  id: response.data.doorjam.id,
                  memberId: response.data.member.id,
                  vehicleId
                });
              }
            } else {
              let text =
                this.$store.getters.TRANSLATIONS["something_went_wrong"];
              this.$modal.show("dialog", {
                text,
                buttons: [
                  {
                    title: "OK",
                    handler: () => {
                      this.$modal.hide("dialog");
                    }
                  }
                ]
              });
            }
          })
          .catch((error) => {
            let text = this.$store.getters.TRANSLATIONS["the_doorjam_code"];
            this.$modal.show("dialog", {
              text,
              buttons: [
                {
                  title: "OK",
                  handler: () => {
                    this.$modal.hide("dialog");
                  }
                }
              ]
            });
          })
          .finally(() => {
            clearTimeout(timeout);
            this.loading = false;
          });
      },
      back: () => {
        this.$router.push(`/${this.$route.query.returnTo}`);
      }
    };
  }
};
</script>

<style scoped src="../../styles/main.css"></style>
<style scoped>
input {
  width: 60%;
  background: transparent !important;
  margin-left: 17vw;
  color: rgba(114, 174, 255, 1) !important;
  border: 0;
  outline: 0;
  border-bottom: 1px solid rgba(114, 174, 255, 1);
}
</style>



// WEBPACK FOOTER //
// src/components/Cars/AddDoorJam.vue